import { Injectable } from '@angular/core';
import { uniq } from 'lodash';

@Injectable({ providedIn: 'root' })
export class PagerUtilities {
    maxPages(maxResults: number, resultsPerPage: number) {
        return Math.ceil(maxResults / resultsPerPage);
    }

    pagingNumbersDisplay(
        currentPageNumber: number,
        maxPages: number,
        ellipsisValue = -1
    ) {
        const maxPageNumbersDisplayed = 5;
        let numbersArray: number[] = [];
        const currentPage = currentPageNumber;

        // If it's short, keep it simple
        if (maxPages <= maxPageNumbersDisplayed) {
            for (let i = 0; i < maxPages; i++) {
                numbersArray.push(i + 1);
            }
        } else {
            const first = 1;
            const last = maxPages;

            // Always display first, current, and last pages
            if (currentPage <= 3) {
                // display first 4 pages ... last page
                numbersArray = [first, 2, 3, 4, currentPage, last];
            } else if (currentPage >= last - 2) {
                // display first page ... last 4 pages
                numbersArray = [
                    first,
                    currentPage,
                    last - 3,
                    last - 2,
                    last - 1,
                    last
                ];
            } else {
                // display first page ... middle 3 pages ... last page
                numbersArray = [
                    first,
                    currentPage - 1,
                    currentPage,
                    currentPage + 1,
                    last
                ];
            }

            // Remove duplicates
            numbersArray = uniq(numbersArray);

            // Sort
            numbersArray.sort((a, b) => a - b);

            // Add ellipses if the pages are more than 1 apart
            const copy: number[] = [];
            numbersArray.forEach((val, index) => {
                copy.push(val);
                const nextVal = numbersArray[index + 1];
                if (nextVal && nextVal - val > 1) {
                    copy.push(ellipsisValue);
                }
            });
            numbersArray = copy;
        }

        return numbersArray;
    }
}
